import { svgSourceBaseUrl, BRAND_NAMES, URL_FOR_BRAND, availableIcons, DEFAULT_BRAND, IconSize } from './constants.js';
import { Brands } from '../theming/constants.js';
import ReactDOMServer from 'react-dom/server';
import { availableTypes } from '../themes/availableIcons.js';

/**
 * encodeIconSVG
 * Takes a React SVG Component (like a Prism Icon) and outputs a URL-encoded
 * string so the component can be used in CSS properties like
 * `background-image`
 * Logic adapted from https://github.com/yoksel/url-encoder
 */
var encodeIconSVG = function encodeIconSVG(data) {
  var symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;
  var svgString = ReactDOMServer.renderToString(data);
  svgString = svgString.replace(/"/g, "'");
  svgString = svgString.replace(/>\s{1,}</g, '><');
  svgString = svgString.replace(/\s{2,}/g, ' ');

  if (svgString.indexOf('http://www.w3.org/2000/svg') < 0) {
    svgString = svgString.replace(/<svg/g, "<svg xmlns='http://www.w3.org/2000/svg'");
  }

  svgString = svgString.replace(symbols, encodeURIComponent);
  return svgString;
};
/**
 * createSvgUrl
 * Takes the icon brand and the type key to create
 * the url for fetching the SVG from our S3 bucket
 */
//research this more. Should be able to make it conditional.

var createSvgUrl = function createSvgUrl(brand, iconKey) {
  return "".concat(svgSourceBaseUrl).concat(brand === BRAND_NAMES[Brands.Caviar] ? URL_FOR_BRAND.Caviar : URL_FOR_BRAND.DoorDash).concat(availableIcons[brand][iconKey]);
};
/**
 * getIconBrand
 * Takes the theme's `Icons.Brand` override and the desired
 * Icon type to determine availability. If icon type is not
 * available for the brand override, default to the
 * DoorDash variant of that Icon type.
 */

var getIconBrand = function getIconBrand(themeBrand, type) {
  var themeBrandName = BRAND_NAMES[themeBrand];

  if (themeBrandName && availableTypes[themeBrandName].hasOwnProperty(type)) {
    return themeBrandName;
  }

  if (availableTypes[DEFAULT_BRAND].hasOwnProperty(type)) {
    return DEFAULT_BRAND;
  }

  return DEFAULT_BRAND;
};
/**
 * iconAvailabilityKey
 * Takes the icon brand, size, and type to determine which
 * variant of the icon to use.
 * Use 16 for \<= IconSize.Small, and 24 for \> IconSize.Small
 * Size "up" the 16 variant if a 24 variant is unavailable for
 * large sizes, size "down" the 24 variant if a 16 variant
 * is unavailable for small sizes.
 */

var iconAvailabilityKey = function iconAvailabilityKey(_ref) {
  var brand = _ref.brand,
      size = _ref.size,
      type = _ref.type;

  if (size !== undefined && size <= IconSize.Small) {
    // if the size is <=16 and there is NOT a 16 variant, render the 24 variant
    if (!availableIcons[brand].hasOwnProperty("16".concat(type))) {
      return "24".concat(type);
    } // if the size is <=16 and there is a 16 variant, render the 16 variant


    return "16".concat(type);
  } // if the size is >16 and there is NOT a 24 variant, render the 16 variant


  if (!availableIcons[brand].hasOwnProperty("24".concat(type))) {
    return "16".concat(type);
  } // if the size is >16 and there is a 24 variant, render the 24 variant


  return "24".concat(type);
};
/**
 * svgAttrUpdates
 * Takes a stringified SVG and applies any desired color overrides
 */

var svgAttrUpdates = function svgAttrUpdates(_ref2) {
  var code = _ref2.code,
      iconColor = _ref2.iconColor,
      useDefaultColors = _ref2.useDefaultColors;
  var iconSvgString = code;

  if (!useDefaultColors) {
    iconSvgString = iconSvgString.replace(/fill="(?!none).*?"/g, "fill=\"".concat(iconColor, "\""));
    iconSvgString = iconSvgString.replace(/stroke="(?!none).*?"/g, "stroke=\"".concat(iconColor, "\""));
  }

  return iconSvgString;
};
/**
 * svgErrorHandler
 * Takes an error object and a callback
 * Warns the user about the error in the console and
 * calls the callback with `true`
 */

var svgErrorHandler = function svgErrorHandler(error, handleSvgFetchError) {
  /* eslint-disable no-console */
  console.warn("Unable to fetch icon file. Error message: ".concat(error.message));
  console.warn('Please reach out to Design Infrastructure team if you encounter this warning.');
  /* eslint-enable no-console */

  handleSvgFetchError(true);
};

export { createSvgUrl, encodeIconSVG, getIconBrand, iconAvailabilityKey, svgAttrUpdates, svgErrorHandler };
